import { render } from "./FooterDetail.vue?vue&type=template&id=78f7cb40&scoped=true"
const script = {}

import "./FooterDetail.vue?vue&type=style&index=0&id=78f7cb40&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f7cb40"]])

export default __exports__